export enum FeeCalculationType {
  MCB = "MCB",
  EDR = "EDR",
  COMBINED = "COMBINED"
}

export enum FeeCalculationStatus {
  NEW = "New",
  TEMP_RUN  = "Temp Run",
  FINAL_RUN = "Final Run"
}



// WEBPACK FOOTER //
// ./src/app/common/enums/FeeCalculation.ts